<template>
  <footer class="footer">
    <div class="footer-container">
      <div>v{{version}} © 2018</div>
      <div>
        <span v-if="icp">{{icp.name}}</span>
        <span v-if="beian">
          <a :href="beian.link" target="_blank" style="text-decoration: none;">
            <span>{{beian.name}}</span>
          </a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import _ from 'lodash'
import { version } from '@/../package.json'
export default {
  data () {
    return {
      id: 'footer-beian',
      version,
      beian: null,
      icp: null
    }
  },
  mounted () {
    if (window._BEIAN) {
      let data = window._BEIAN.parse('dartcome.com')
      this.beian = _.get(data, 'beian')
      this.icp = _.get(data, 'icp')
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.footer {
  text-align: center;
  font-size: 10px;
  color: var(--colorDisabled);
  & span {
    color: var(--colorDisabled);
  }
  & .footer-container {
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Footer.vue